export const defaultLang = {
    'LANG': 'es',
    'ADD': 'Agregar',
    'FILTER': 'Filtrar',
    'FILTERS': 'Filtros',
    'DIMENSIONS': 'Dimensiones',
    'HOME': 'Inicio',
    'USERS': 'Usuarios',
    'USER': 'Usuario',
    'PLOT': 'Parcela',
    'PLOTS': 'Parcelas',
    'COMMERCES': 'Comercios',
    'COMMERCE': 'Comercio',
    'DOCUMENT': 'Documento',
    'DOCUMENTS': 'Documentos',
    'PURCHASER': 'Comprador',
    'FEEDBACK': 'Comentario',
    'FEEDBACKS': 'Comentarios',
    'NOTIFICATION': 'Correo',
    'AUDIT': 'Auditoría',
    'CONTENT': 'Contenido',
    'SEARCH': 'Buscar',
    'NAME': 'Nombre',
    'EMAIL': 'Correo',
    'ROLES': 'Roles',
    'DATE': 'Fecha',
    'HOUR': 'Hora',
    'STATE': 'Estado',
    'SELECT': 'Seleccione',
    'ORGANIZATION': 'Organización',
    'JOB_TITLE': 'Título',
    'SEX': 'Sexo',
    'LAST_NAME': 'Apellido',
    'PHONE': 'Teléfono',
    'RUC': 'RUC',
    'PASSWORD': 'Contraseña',
    'CONFIRM_PASSWORD': 'Confirmar Contraseña',
    'USER_ADMIN': 'Administración de Usuarios',
    'CONTENT_ADMIN': 'Administración de Contenido',
    'COMMERCE_ADMIN': 'Administración de Comercios',
    'DOCUMENT_ADMIN': 'Administración de Documentos',
    'AUDIT_ADMIN': 'Administración de Auditoria',
    'EMAIL_ADMIN': 'Administración de Correos',
    'FEEDBACK_ADMIN': 'Administración de Comentario',
    'SUPER_ADMIN': 'Super Administrador',
    'USER_EDIT': 'Editar Usuario',
    'USER_CREATE': 'Nuevo Usuario',
    'SIGN_IN': 'Iniciar Sesión',
    'MALE': 'Hombre',
    'FEMALE': 'Mujer',
    'USER_CREATED_TITLE': 'Crear Usuario',
    'USER_CREATED_SUCCESS_MESSAGE': 'El usuario se ha creado con éxito',
    'USER_UPDATED_TITLE': 'Editar Usuario',
    'USER_UPDATED_SUCCESS_MESSAGE': 'El usuario se ha editado con éxito',
    'PASSWORD_DO_NOT_MATCH': 'La contraseña y la contraseña de confirmación no coinciden',
    'MISSING_REQUIRED_ARGUMENTS_USER_EDITOR': 'Faltan los siguientes campos requeridos',
    'USER_DELETE_CONFIRM_TITLE': 'Eliminar Usuario',
    'USER_DELETE_CONFIRM_BODY': 'Esta seguro que desea eliminar al usuario <b>%s</b> con el correo <b>%s</b>',
    'CLOSE': 'Cerrar',
    'CANCEL': 'Cancelar',
    'SAVE': 'Guardar',
    'USER_ADMIN_MODULE_NAME': 'Módulo de Administración de Usuarios',
    'COMMERCE_ADMIN_MODULE_NAME': 'Módulo de Administración de Comercios',
    'CONTENT_ADMIN_MODULE_NAME': 'Módulo de Administración de Contenido',
    'EMAIL_ADMIN_MODULE_NAME': 'Módulo de Administración de Correos',
    'AUDIT_ADMIN_MODULE_NAME': 'Módulo de Auditoría',
    'PLOT_ADMIN_MODULE_NAME': 'Módulo de Parcelas',
    'PENDING': 'Pendiente',
    'VIEWED': 'Visto',
    'ACKNOWLEDGE': 'Aceptado',
    'REJECTED': 'Rechazado',
    'ADDRESS': 'Dirección',
    'LEGAL_REPRESENTATIVE': 'Representante legal',
    'NATIONALITY': 'Nacionalidad',
    'COMMERCE_REGISTER_TYPE': 'Tipo de registro',
    'COMMERCE_RESOLUTION': 'Resolución',
    'IS_IN_ZLC': 'Establecido la en ZLC',
    'COMMERCE_OPERATIONS_KEY': 'Clave de operaciones',
    'ACTIVITY_DESCRIPTION': 'Actividades a desarrollar',
    'PRODUCTS_DESCRIPTION': 'Productos que manejara',
    'IMPORT_COUNTRIES': 'Países de importación',
    'EMPLOYEES': 'Número de empleos permanentes a generar',
    'OBSERVATIONS': 'Observaciones',
    'STATUS': 'Estatus',
    'COMMERCE_HISTORY': 'Historial',
    'COMMERCE_DOCUMENTS': 'Documentos',
    'COMMERCE_REJECTED_JUSTIFICATION': 'Justificación',
    'NOTICE_OPERATIONS': 'Aviso de operaciones',
    'PEACE_SAVE': 'Paz y salvo',
    'LEGAL_REPRESENTATIVE_ID': 'Identificación del representante legal',
    'PUBLIC_RECORD_CERTIFICATE': 'Certificado de registro público',
    'AFFIDAVIT_LEGAL_REPRESENTATIVE': 'Declaramentación jurada del representante legal',
    'HIRING_COMMITMENT_PROPOSAL': 'Propuesta de compromiso de contratación de mano de obra',
    'COMMERCE_CREATED_BY': 'Realizado por',
    'TITLE': 'Título',
    'TYPE': 'Tipo',
    'ACTIVE': 'Activo',
    'INACTIVE': 'Inactivo',
    'DESCRIPTION': 'Descripción',
    'START_DATE': 'Fecha de inicio',
    'END_DATE': 'Fecha final',
    'EXPIRATION_DATE': 'Fecha de expiración',
    'DOCUMENT_FILE': 'Archivo',
    'SPANISH': 'Español',
    'ENGLISH': 'Inglés',
    'DOCUMENTS_NEW': 'Nuevo documento',
    'DOCUMENTS_UPDATE': 'Actualizar documento',
    'DOCUMENTS_UPDATE_SECTION_TITLE': 'Actualizar documento existente',
    'DOCUMENTS_UPDATE_FILENAME': 'Nombre del documento',
    'DOCUMENTS_AVAILABILITY_SECTION_TITLE': 'Fechas de disponibilidad',
    'DOCUMENTS_DATE_ERROR': 'La fecha de expiración tiene que ser después de la fecha de inicio',
    'DOCUMENTS_SELECT_FILE_DEFAULT': 'Selecciona un archivo',
    'DOCUMENTS_DELETE_CONFIRM_TITLE': 'Eliminar Documento',
    'DOCUMENTS_DELETE_CONFIRM_BODY': 'Esta seguro que desea eliminar el documento <b>%s</b>',
    'DOCUMENTS_SAVED_SUCCESSFULLY_TITLE': 'Documento',
    'DOCUMENTS_SAVED_SUCCESSFULLY_BODY': 'El documento fue guardado exitosamente',
    'LOG_OUT': 'Cerrar sesión',
    'GENERAL_ERROR': 'Occurio un error',
    'INVALID_CREDENTIALS_ERROR': 'El usuario o la contraseña son incorrectas, intente nuevamente',
    'TIMEOUT_ERROR': 'Se acabó el tiempo de la sesión por favor inicie sesión nuevamente',
    'ABSTRACT': 'Resumen',
    'CONTENTS_NEW': 'Nuevo contenido',
    'CONTENT_UPDATE': 'Actualizar contenido',
    'NEWS': 'Noticia',
    'ANNOUNCEMENT': 'Anuncio',
    'EVENT': 'Evento',
    'CONTENT_MODAL_TITLE': 'Editar contenido',
    'CONTENT_IMAGES_TITLE': 'Imágenes',
    'CONTENT_COVER_IMAGE': 'Cubierta',
    'CONTENT_THUMBNAIL_IMAGE': 'Miniatura',
    'CONTENT_SELECT_FILE_DEFAULT': 'Selecciona una imagen',
    'CONTENT_INVALID_IMAGE_TYPE': 'Seleccione una imagen con extension valida',
    'CONTENT_SAVED_SUCCESSFULLY_TITLE': 'Contenido',
    'CONTENT_SAVED_SUCCESSFULLY_BODY': 'El contenido fue guardado exitosamente',
    'CONTENT_DELETE_CONFIRM_TITLE': 'Eliminar Contenido',
    'CONTENT_DELETE_CONFIRM_BODY': 'Esta seguro que desea eliminar el contenido <b>%s</b>',
    'CREATE_CONTENT_SUCCESS_MODAL_ADD_DATA': `Se creo %s <b>%s</b> con éxito ahora haga click en <b>Siguiente</b> para abrir el editor`,
    'NEXT': 'Siguiente',
    'CONTENT_MODAL_LANGUAGE': 'Rellene todos los lenguajes',
    'CONTENTS': 'Contenido',
    'EMAIL_LIST_NEW': 'Nueva lista de correo',
    'EMAIL_LIST_TYPE_TITLE': 'Tipo de evento',
    'EMAIL_LIST_COUNT_TITLE': 'Correos',
    'EMAIL_LIST_TYPE_NEW_USER': 'Nuevo usuario',
    'EMAIL_LIST_SAVED_SUCCESSFULLY_TITLE': 'Correos',
    'EMAIL_LIST_SAVED_SUCCESSFULLY_BODY': 'Los correos fueron guardados exitosamente',
    'EMAIL_INPUTS_INVALID': 'Uno o más correos son inválidos',
    'FEEDBACK_ADMIN_MODULE_NAME': 'Módulo de Administración de Comentario',
    'FEEDBACK_SUBJECT_TITLE': 'Asunto',
    'FEEDBACK_TYPE_TITLE': 'Tipo',
    'FEEDBACK_EMAIL_TITLE': 'Correo',
    'FEEDBACK_DATE_TITLE': 'Fecha',
    'FEEDBACK_TYPE_FEEDBACK': 'Comentario',
    'FEEDBACK_TYPE_COMPLAINT': 'Queja',
    'FEEDBACK_TYPE_CONGRATULATIONS': 'Felicitaciones',
    'LOGS': 'Logs',
    'MODULE': 'Módulo',
    'LOADING': 'Cargando',
    'ACTION': 'Acción',
    'ERROR_START_DATE_BIGGER_THAN_END_DATE': `La fecha inicial no puede ser despues que la fecha final`,
    'ERROR_END_DATE_SMALLER_THAN_START_DATE': `La fecha final no puede ser antes de la fecha inicial`,
    'ERROR_ONLY_PDF': `Solo estan permitidos archivos pdf`,
    'ERROR_RESOLUTION_REQUIRED': `El archivo de resolución es requerido`,
    'ERROR_RESOLUTION_NOT_AVAILABLE': `El archivo de resolución no esta disponible`,

    // ACTIONS
    'CREATE': 'Crear',
    'DOWNLOAD': 'Descargar',
    'DELETE': 'Borrar',
    'UPDATE': 'Actualizar',
    'READ': 'Leer',

    // EVENT TYPES
    'EVT_CREATE_USER': 'Crear usuario',
    'EVT_UPDATE_USER': 'Actualizar usuario',
    'EVT_DELETE_USER': 'Borrar usuario',
    'EVT_CREATE_DOCUMENT': 'Crear documento',
    'EVT_UPDATE_DOCUMENT': 'Actualizar documento',
    'EVT_DELETE_DOCUMENT': 'Borrar documento',
    'EVT_CREATE_CONTENT': 'Crear contenido',
    'EVT_UPDATE_CONTENT': 'Actualizar contenido',
    'EVT_UPLOAD_IMAGE_CONTENT': 'Subir imagen de contenido',
    'EVT_DELETE_CONTENT': 'Borrar contenido',
    'EVT_CREATE_COMMERCE': 'Crear comercio',
    'EVT_CREATE_FEEDBACK': 'Crear comentario',
    'EVT_GET_DOCUMENT_BY_ID': 'Obtener documento por ID',
    'EVT_DOWNLOAD_COMMERCE_DOCUMENTS_BY_ID': 'Descargar documentos de comercio por ID',
    'EVT_SET_NOTIFICATION_EMAIL': 'Configurar listado de correos',
    'EVT_CREATE_PURCHASER': 'Registrar comprador',
    'EVT_GET_REQUEST_COMMERCES': 'Obtener comercios',
    'EVT_GET_COMMERCE_HISTORY_BY_ID': 'Obtener historial de comercio',
    'EVT_GET_FEEDBACK_BY_ID': 'Obtener comentario por ID',
    'EVT_GET_NOTIFICATION_EMAIL_BY_ID': 'Obtener lista de correos por ID',
    'EVT_GET_ALL_NOTIFICATIONS_EMAIL': 'Obtener listados de correos',
    'EVT_GET_USER_BY_ID': 'Obtener usuario por ID',
    'EVT_GET_COMMERCE_DOCUMENTS_BY_ID': 'Obtener documentos de comercio',
    'EVT_GET_ALL_USERS': 'Obtener usuarios',
    'EVT_GET_ALL_FEEDBACK': 'Obtener comentarios',
    'EVT_GET_COMMERCE_BY_ID': 'Obtener commercio'
};